import { copyTextWithNotify } from "@/helpers/clipboard.helper";
import { Button, Input, Modal, ModalProps, Stack, Text, useToasts } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface WebhookSecretModalProps extends ModalProps {
  secret: string;
}

export function WebhookSecretModal({ secret, ...props }: WebhookSecretModalProps) {
  const { showInfo } = useToasts();
  const { t } = useTranslation();

  const copySecret = () => {
    void copyTextWithNotify(secret).then((copied) => {
      if (!copied) return;
      showInfo({ title: t("common:copied") });
    });
  };

  return (
    <Modal
      {...props}
      title={t("core:webhook_secret_title")}
      withCloser
      closeByOutsidePress={false}
      actions={
        <Stack>
          <Button size={"lg"} onClick={copySecret}>
            {t("core:to_copy")}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"md"}>
        <Text>{t("core:webhook_secret_description")}</Text>
        <Input label={t("core:webhook_secret")} value={secret} readOnly />
      </Stack>
    </Modal>
  );
}
